import * as React from 'react';
import { ErrorType, pickForegroundColor, styled, } from '@workday/canvas-kit-react/common';
import { colors, commonColors, type } from '@workday/canvas-kit-react/tokens';
const optionPadding = 6;
const activeStyles = (theme) => {
    const activeBgColor = theme.canvas.palette.primary.main;
    return {
        backgroundColor: activeBgColor,
        color: pickForegroundColor(activeBgColor),
    };
};
const Option = styled('li')({
    ...type.levels.subtext.large,
    cursor: 'default',
    // Apply listStyle at the list item style to ensure it's styled properly
    // in Visual Testing States
    listStyle: 'none',
    // In case the content of the option is empty/undefined for some reason
    minHeight: type.levels.subtext.large.lineHeight,
    textAlign: 'left',
}, ({ 'aria-disabled': disabled, focused, interactive, theme }) => {
    if (disabled) {
        // If the option is disabled, return disabled styles...
        return {
            color: colors.licorice100,
        };
    }
    else if (focused) {
        // ...else if the option is focused, return focused styles...
        return {
            ...activeStyles(theme),
        };
    }
    else {
        // ...else return hover and selected (via aria-selected) styles
        const selectedBgColor = theme.canvas.palette.primary.lightest;
        const selectedStyles = {
            '&[aria-selected="true"]': {
                backgroundColor: selectedBgColor,
                color: pickForegroundColor(selectedBgColor),
            },
        };
        // Only display interactive (hover/active) styles if the option is interactive
        const interactiveStyles = interactive
            ? {
                '&:hover': {
                    backgroundColor: commonColors.hoverBackground,
                },
                '&:active, &:active[aria-selected="true"]': {
                    ...activeStyles(theme),
                },
            }
            : {};
        return {
            // Place selected styles after interactive styles to have selected styles
            // override interactive styles (subject to CSS specificity rules)
            ...interactiveStyles,
            ...selectedStyles,
        };
    }
}, ({ error }) => ({
    padding: `${optionPadding}px ${error === ErrorType.Alert ? optionPadding - 1 : optionPadding}px`,
}));
export const SelectOption = ({ children, focused = false, interactive = true, optionRef, value, ...elemProps }) => {
    return (React.createElement(Option, Object.assign({ "data-value": value, focused: focused, interactive: interactive, ref: optionRef, role: "option" }, elemProps), children));
};
